import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import "../styles/Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="nav-container">
        {/* Left side: logo + slogan */}
        <div className="nav-brand">
          <div className="nav-logo">AHS</div>
          <div className="nav-slogan">
            Elevate Your Projects with Precision: AVEVA E3D &amp; Hexagon SP3D
          </div>
        </div>

        {/* Nav links */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
  <li><a href="#catalogs" onClick={() => setMenuOpen(false)}>Admin</a></li>
  {/* <li><a href="#catalogs" onClick={() => setMenuOpen(false)}>Catalogs</a></li> */}
  <li><a href="#diagrams" onClick={() => setMenuOpen(false)}>Catalogs</a></li>
  {/* <li><a href="#tags" onClick={() => setMenuOpen(false)}>Tags</a></li> */}
  <li><a href="#isodraft" onClick={() => setMenuOpen(false)}>Draw</a></li>
  <li><a href="#design" onClick={() => setMenuOpen(false)}>Design</a></li>
  {/* <li><a href="#projects" onClick={() => setMenuOpen(false)}>Projects</a></li> */}
  <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a></li>
</ul>

        {/* Hamburger menu (mobile) */}
        <button
          className="menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
    </header>
  );
}



